import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'

export function* setPhysicianTypeOption() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getPhysicianTypeOptions,
    ])
    const { entity } = response
    yield put(actions.setPhysicianTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setPhysicianTypeOption() error: ${e}`))
  }
}
export function* setPhysicianTypeOptionSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setPhysicianTypeOption)
}
